import { render, staticRenderFns } from "./Multi_product_page.vue?vue&type=template&id=0664dd22&"
import script from "./Multi_product_page.vue?vue&type=script&lang=js&"
export * from "./Multi_product_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports